import { MasterDataService } from 'src/app/services/master-data.service';
import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-my-penalty-summary',
  templateUrl: './my-penalty-summary.component.html',
  styleUrls: ['./my-penalty-summary.component.css'],
})
export class MyPenaltySummaryComponent implements OnInit {
  selectedClosing;
  closingDateList;
  reportList = null;
  financialList;
  selectedFinancialYear;

  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) {}

  ngOnInit(): void {
    this.selectedFinancialYear="";
    this.selectedClosing="";
    this.getFinancialYear();
  }

  getFinancialYear() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
      console.log('financialyear list', this.financialList);
    });
  }

  getClosingDate() {
    this.selectedClosing="";
    if(this.selectedFinancialYear!=null && this.selectedFinancialYear!=undefined && this.selectedFinancialYear!=""){
    this.masterDataService
      .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
      .subscribe((res) => {
        this.closingDateList = res;
        var notClosedobject= {
          id :  0,
          closingDate: "Not Closed"
        }
        this.closingDateList.push(notClosedobject)
        console.log('closing list', res);
      });
    }
  }
  onViewReport() {
    if(this.selectedFinancialYear==""||this.selectedFinancialYear==undefined ||this.selectedFinancialYear==null||
      this.selectedClosing==""||this.selectedClosing==undefined || this.selectedClosing==null){
      this.commonMessageService.swalAlertWithoutIcon('','Please Choose All the Values');
      return;
    }
    this.masterDataService
      .getPanaltySummary(0, 0, this.selectedClosing, localStorage.getItem('id'))
      .subscribe((res) => {
        //this.reportList =res[0].role;
        this.reportList = res;
        console.log('reportlist........', res);
         if(this.reportList.length == 0){
          this.commonMessageService.swalAlertWithoutIcon('','No records found');
        }
      });
  }
}
